// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseConfig = {
  apiKey: "AIzaSyD0AXTKNsz7zwCuJNEFXEXQK4NP8Xie9OE",
  authDomain: "sk-trans-ua.firebaseapp.com",
  databaseURL: "https://sk-trans-ua-default-rtdb.firebaseio.com",
  projectId: "sk-trans-ua",
  storageBucket: "sk-trans-ua.appspot.com",
  messagingSenderId: "204180301894",
  appId: "1:204180301894:web:2d6d93d45c4954f79d4247",
  measurementId: "G-PYWKGX363X"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();